import { useLocation } from "react-router";
import CustomTypography from "../Typography/CustomTypography";

export default function PageName({ pageName }: { pageName?: string }) {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const lastPart = parts.filter(Boolean).pop();
  return (
    <div className="flex items-center py-2">
      <CustomTypography
        as="h1"
        family={"kanit"}
        case={"uppercase"}
        size={"21px"}
        weight={"medium"}
      >
        {pageName ? pageName : lastPart}
      </CustomTypography>
    </div>
  );
}
